<template>
    <div>
        <!--  设置工时 -->
        <el-form ref="form" :rules="rules" :model="form" label-width="80px" class="event-form">
            <el-form-item label="编号">
                <el-input v-model="form.case_sn" disabled></el-input>
            </el-form-item>
            <el-form-item label="工作者" prop="requesterName">
                <div class="el-form__inline">
                    <el-input type="text" placeholder="请选择工作者" disabled v-model="form.requesterName"></el-input>
                    <router-link :to="{ path:'/requesterList',query: { callback:getRequester } }">
                        <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                    </router-link>
                </div>
            </el-form-item>
            <el-form-item label="时长" prop="timeLength">
                <div class="el-form__inline">
                    <el-input v-model="form.timeLength" type='number' :min="0"></el-input>
                    <span style="font-size:15px;margin-left:4%;">小时</span>
                </div>
            </el-form-item>
            <el-form-item label="创建者">
                <el-input v-model="form.createUser" disabled></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit">确定</el-button>
                <el-button type="default" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import commonService from "../../services/common.service"
    import { getRules } from "./common.rules";
    const rules = getRules();
    export default {
        props:{
            serialNumber:String,
            callback:Function
        },
        data() {
            return {
                formName:"form",
                form:{
                    case_sn:"",
                    timeLength:"",
                    createUser:"",
                    requesterName:""
                },
                requesterName:"",
                requesterId:"",
                requesterInfo:{},
                rules:rules
            }
        },
        created() {
            this.form.case_sn = this.serialNumber;
            this.form.createUser = this.user;
        },
        computed:{
            user(){
                return this.$store.state.userInfo.user.username;
            },
        },
        methods: {
            // 选择的请求人
            getRequester(obj){
                this.requesterInfo = {
                    id:obj.internalUserid,
                    name:obj.name
                };
                this.form.requesterName = obj.name;
            },
            submit(){
                let formName = this.formName;
                this.$refs[formName].validate((valid) => {
                    if(valid){
                        this.addHours();
                    };
                    return valid;
                })
            },
            addHours(){
                let params = {
                    case_sn:this.form.case_sn,
                    worker:this.requesterInfo.id,
                    timeLength:this.form.timeLength,
                    createUser:this.form.createUser
                };
                commonService.addWork(params).then(res => {
                    this.$message.success("设置工时成功");
                    this.close(true);
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>